import type { PageType } from 'types/page_type';

export const homePage: Readonly<PageType> = {
  path: '/home',
  title: 'Home',
  description: 'ホーム',
};
